import React, { createContext, useContext } from 'react';

import { PaymentError } from '../core/payment-error';
import { PaymentFeatureFlags } from '../types';

interface FeatureFlagsContextValue {
    isEnabled: (flag: keyof PaymentFeatureFlags) => boolean;
    flags: PaymentFeatureFlags;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue | undefined>(
    undefined
);

interface FeatureFlagsProviderProps {
    children: React.ReactNode;
    flags?: PaymentFeatureFlags;
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({
    children,
    flags = {}
}) => {
    const isEnabled = (flag: keyof PaymentFeatureFlags): boolean => {
        return flags[flag] ?? false;
    };

    const value: FeatureFlagsContextValue = {
        isEnabled,
        flags
    };

    return (
        <FeatureFlagsContext.Provider value={value}>
            {children}
        </FeatureFlagsContext.Provider>
    );
};

export const useFeatureFlags = (): FeatureFlagsContextValue => {
    const context = useContext(FeatureFlagsContext);
    if (!context) {
        throw new PaymentError(
            'useFeatureFlags must be used within FeatureFlagsProvider',
            'VALIDATION_ERROR'
        );
    }
    return context;
};
